"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DEFAULT_STAGE_NAME = exports.DEFAULT_SERVICE_NAME = exports.DEFAULT_REGION_NAME = void 0;
exports.DEFAULT_REGION_NAME = 'us-east-1';
exports.DEFAULT_SERVICE_NAME = 'rbi';
exports.DEFAULT_STAGE_NAME = 'localdev';